import { render } from "./Admin.Businesses.vue?vue&type=template&id=0fe04a94"
import script from "./Admin.Businesses.vue?vue&type=script&lang=js"
export * from "./Admin.Businesses.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__